import React from 'react';
import { CTAButton } from './ui/CTAButton';
import { ShieldCheckIcon, LockIcon, CreditCardIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="pt-24 md:pt-32 pb-10 md:pb-16 px-4 bg-white text-center" data-id="element-168">
      <div className="max-w-4xl mx-auto" data-id="element-169">
        <div className="inline-block bg-brand-light text-brand-blue font-bold px-4 py-1 rounded-full mb-4 md:mb-6 border border-brand-blue/20" data-id="element-170">
          🧬 BIOLOGÍA EN ACCIÓN
        </div>

        <h1 className="text-3xl md:text-5xl font-black text-brand-dark mb-2 leading-tight tracking-tight" data-id="element-171">
          Todo tu año de Biología <br className="hidden md:block" data-id="element-172" />
          <span className="text-brand-blue underline decoration-brand-orange decoration-4 md:decoration-8 underline-offset-4 md:underline-offset-8" data-id="element-173">
            resuelto.
          </span>
        </h1>

        <a href="#compra" className="block cursor-pointer transform hover:scale-[1.02] transition-transform duration-300 mb-5 md:mb-8" data-id="element-174">
          <img src="https://cdn.magicpatterns.com/uploads/pD6zazqouU3A1pvrCVRtRK/ChatGPT_Image_19_dic_2025,_07_13_20_p.m..png" alt="MegaPack Biología en Acción" className="w-full max-w-2xl mx-auto drop-shadow-2xl rounded-xl" data-id="element-175" />
        </a>

        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4" data-id="element-176">
          BIOLOGÍA EN ACCIÓN — 6 Tomos + 3 Bonos + Sistema VIP
        </h2>

        <p className="text-xl md:text-2xl italic text-gray-600 font-medium mb-5 md:mb-8" data-id="element-177">
          "Planificación total. De 1° a 6° año."
        </p>

        <p className="text-lg md:text-xl text-gray-700 max-w-3xl mx-auto mb-6 md:mb-10 leading-relaxed" data-id="element-178">
          El sistema que usan cientos de profesores de Biología de secundaria en
          Argentina para organizar sus clases de todo el ciclo básico y superior
          en una tarde — sin improvisar, sin buscar en Google y recuperando sus
          domingos.
        </p>

        <div className="flex flex-wrap justify-center gap-2 md:gap-4 mb-6 md:mb-10" data-id="element-179">
          <span className="flex items-center gap-2 bg-gray-100 px-4 py-2 rounded-lg font-semibold text-gray-800" data-id="element-180">
            📄 100% PDF
          </span>
          <span className="flex items-center gap-2 bg-gray-100 px-4 py-2 rounded-lg font-semibold text-gray-800" data-id="element-181">
            ⚡ Acceso inmediato
          </span>
          <span className="flex items-center gap-2 bg-gray-100 px-4 py-2 rounded-lg font-semibold text-gray-800" data-id="element-182">
            🇦🇷 Currículo argentino (PBA + NAP)
          </span>
        </div>

        <div className="max-w-2xl mx-auto mb-6" data-id="element-183">
          <CTAButton text="🧬 → QUIERO MI MEGAPACK AHORA" href="#compra" isLink={true} data-id="element-184" />
        </div>

        <div className="flex flex-wrap justify-center items-center gap-6 text-sm md:text-base text-gray-600 font-medium" data-id="element-185">
          <span className="flex items-center gap-1" data-id="element-186">
            <ShieldCheckIcon className="w-5 h-5 text-brand-green" data-id="element-187" /> Garantía 7
            días sin preguntas
          </span>
          <span className="flex items-center gap-1" data-id="element-188">
            <LockIcon className="w-5 h-5 text-gray-500" data-id="element-189" /> Pago 100% seguro
          </span>
          <span className="flex items-center gap-1" data-id="element-190">
            <CreditCardIcon className="w-5 h-5 text-blue-500" data-id="element-191" /> Mercado Pago
          </span>
        </div>
      </div>
    </section>;
}